// extracted by mini-css-extract-plugin
export default {"shimmer":"Button_shimmer__TbIA6","dark_shimmer":"Button_dark_shimmer__pkELe","button":"Button_button__w+JtY","loader":"Button_loader__y1VGI"};